import Backbone from '@polleverywhere/backbone'

/**
 * Comparison data between two MCP activities.
 */
export default class Comparison extends Backbone.Model {
  get idAttribute () {
    return 'presenter_key'
  }
}
